module.exports = __webpack_public_path__ + "img/Double Deluxe Superior room - lagoon view.9c3c3c36.jpg";